<ng-container *transloco="let _t">
<div class="row">
<h3 class="darkbg text-center">{{indicator.name}}</h3>

<!-- Objectif -->
<button mat-raised-button *ngIf="!objectif"
color="accent" class="objButton"
(click)="newObjectif()">
<mat-icon>account_tree</mat-icon>
{{ _t('rm-indicator-button-0') }}
</button>

<button mat-raised-button *ngIf="objectif!=null && !embedded"
color="basic" class="objButton"
(click)="openObjectif()">
<mat-icon>account_tree</mat-icon>
{{ _t('rm-indicator-button-1') }}
</button>

<p>{{indicator.description}}</p>
<div class="row">
	<!-- Infos -->
	<div class="col-4 frame">
		<ul>
			<li><strong>{{ _t('rm-indicator-strong-0') }} </strong> 
				{{indicator.answer.gravityScore}} x {{indicator.answer.evolution}} = {{indicator.answer.score}}
			</li>
			<li>
				<strong>{{ _t('rm-indicator-strong-1') }} </strong>
				<mat-icon
					[ngStyle]="{'color': indicator.answer.slice.color}" class="puce" >
						radio_button_checked</mat-icon>
				<span> &nbsp; {{indicator.answer.slice.name}}
				</span>
			</li>
			<li>
				<strong>{{ _t('rm-indicator-strong-2') }} </strong>
				{{indicator.answer.revelent}}
			</li>
		</ul>
	</div>
	<!-- freephoto -->
	<div class="col-4 frame">
		<h5>{{ _t('rm-indicator-h5-0') }}</h5>
		<div class="pics" [id]="'pics-'+indicator.id">
				
			<cmat-picture *ngFor="let photo of indicator.answer.freephoto; let i=index"
				[src]="photo" 
				[alt]="'Photo '+(i+1)" 
				[uploadable]="false"
				[path]="'b'+diagnostic.building.id+'-d'+diagnostic.id+'-i'+indicator.id"
				[filename]="'p'+i"
				[ngStyle]="{ 'left': (i*33)+'%' }"></cmat-picture>
			
		</div>
	</div>
	<!-- commentaire -->
	<div class="col-4 frame">
		<h5>{{ _t('rm-indicator-h5-1') }}</h5>
		<p>{{indicator.answer.freetext}}</p>
	</div> 
</div>		

<p>&nbsp;</p>
<!-- gravité + évolution -->
<div class="col-12 row gravity-evolution">

	<!-- GRAVITÉ -->
	<div class="col-7 gravity frame">
		<h3 class="text-center">{{ _t('rm-indicator-h2-1') }}</h3>

		<!-- Mode additif / soustractif -->
		<div *ngIf=" indicator.multichoicegravity!=0 else unichoicegravity">
			<p><mat-icon color="warn">warning</mat-icon> {{ _t('rm-indicator-p-2') }}</p>

			<ol class="gravities">
			<li *ngFor="let gravity of indicator.gravities; let g=index; "
				[ngClass]="{'choosen':indicator.answer.gravityArray[g]}">
				{{gravity.label}}
			</li>
			</ol>
		</div>

		<!-- Mode exclusif -->
		<ng-template #unichoicegravity>
			<ol class="gravities">
			<li *ngFor="let gravity of indicator.gravities; let g=index;"
				[ngClass]="{'choosen': gravity.weight == indicator.answer.gravityScore}">
				{{gravity.label}}
			</li>
			</ol>
		</ng-template>
	</div>

	<!-- EVOLUTION -->
	<div class="col-5 evolution frame">
		<h3 class="text-center">{{ _t('rm-indicator-h2-2') }}</h3>
		<ol class="gravities">
			<li *ngFor="let evolution of indicator.evolutions; let e=index; "
				[ngClass]="{'choosen':indicator.answer.evolution==(e+1)}">
				{{evolution}}
		</ol>
	</div>
</div> <!-- /gravité + évolution -->

<p>&nbsp;</p>

<!-- Préconisations -->

<div class="col-12 row">
  <div class="frame">
	<h3 *ngIf="indicator.preco" class="text-center">{{ _t('rm-indicator-h2-3') }}</h3>
	<div *ngIf="indicator.preco"
		class="preco" [innerHtml]="indicator.preco.preco"></div>
  </div>
</div>

</div>
</ng-container>